
import {
  cityName,
  directionsUrl,
  formatKm,
  websiteUrl,
} from '@/utils/partnerLocator'

export default {
  name: 'PartnerLocatorItem',
  props: {
    partner: {
      type: Object,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    logo() {
      return this.partner.image?.url || require('~/assets/images/partner.png')
    },
    city() {
      return cityName(this.partner.city)
    },
    distance() {
      return this.partner.distance === undefined
        ? ''
        : formatKm(this.partner.distance, this.$i18n.locale)
    },
    foreignCountry() {
      const iso = this.partner.country?.iso
      return iso && iso.toUpperCase() !== 'FR' ? this.partner.country.name : ''
    },
    directions() {
      return directionsUrl(this.partner)
    },
    website() {
      return websiteUrl(this.partner.website)
    },
  },
}
